import React from "react";
import { StyleSheet, Pressable } from "react-native";
import Text from "@components/CustomText";
import color from "@constants/color";

interface TabButtonProps {
  title: string;
  isActive: boolean;
  onPress: () => void;
}

const TabButton: React.FC<TabButtonProps> = ({ title, isActive, onPress }) => (
  <Pressable
    onPress={onPress}
    style={[styles.tabButton, isActive && styles.activeTabButton]}
  >
    <Text
      variant="title_16"
      style={[styles.tabButtonText, isActive && styles.activeTabButtonText]}
    >
      {title}
    </Text>
  </Pressable>
);

export default TabButton;

const styles = StyleSheet.create({
  tabButton: {
    flex: 1,
    paddingVertical: 12,
    alignItems: "center",
    justifyContent: "center",
  },
  activeTabButton: {
    backgroundColor: color.mediumBlack,
    borderRadius: 50,
  },
  tabButtonText: {
    color: color.mediumBlack,
  },
  activeTabButtonText: {
    color: color.white,
  },
});
